import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { PracticeAreas } from "@/components/PracticeAreas";
import { WalkIn } from "@/components/WalkIn";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import Privacy from "@/pages/Privacy";
import Complaints from "@/pages/Complaints";
import Terms from "@/pages/Terms";
import Accessibility from "@/pages/Accessibility";
import { useLenis } from "@/hooks/useLenis";

const ToasterMount = () => (
  <Toaster
    position="top-right"
    theme="dark"
    toastOptions={{
      style: {
        background: "#14141A",
        border: "1px solid rgba(233,199,106,0.25)",
        color: "#F5F2E8",
        borderRadius: 0,
        fontFamily: "Outfit, sans-serif",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
      },
    }}
  />
);

const Home = () => {
  useLenis();
  return (
    <div className="App" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <About />
        <PracticeAreas />
        <WalkIn />
        <Team />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
      <ToasterMount />
    </div>
  );
};

const LegalRoute = ({ children }) => {
  useLenis();
  return (
    <>
      {children}
      <CookieBanner />
      <ToasterMount />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<LegalRoute><Privacy /></LegalRoute>} />
        <Route path="/complaints" element={<LegalRoute><Complaints /></LegalRoute>} />
        <Route path="/terms" element={<LegalRoute><Terms /></LegalRoute>} />
        <Route path="/accessibility" element={<LegalRoute><Accessibility /></LegalRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
